.iframe-container {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.loader {
  position: absolute;
  inset: 0;
}

.iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* Mantine Drawer overrides */
.drawer-content {
  display: flex;
  flex-direction: column;
}

.drawer-header {
  border-bottom: 1px solid var(--mantine-color-default-border);
}

.drawer-body {
  flex: 1;
  padding: 0;
  overflow: hidden;
}
